import React, { forwardRef, isValidElement } from 'react';
import PropTypes from 'prop-types';
import Text from '../Text';
import { SectionHeaderProps } from './SectionHeader.types';
import { st, classes } from './SectionHeader.st.css';

const SectionHeader = forwardRef<HTMLDivElement, SectionHeaderProps>(
  (
    {
      dataHook,
      title,
      suffix,
      id,
      'aria-describedby': ariaDescribedBy,
      as = 'span',
      skin = 'standard',
      size = 'medium',
      align = 'start',
      divider = 'default',
      horizontalPadding = 'large',
    },
    ref,
  ) => {
    return (
      <div
        ref={ref}
        data-hook={dataHook}
        className={st(classes.root, {
          skin,
          horizontalPadding,
          divider,
          size,
        })}
      >
        <div className={st(classes.title, { align })} data-hook="title-node">
          {isValidElement(title) ? (
            title
          ) : (
            <Text
              id={id}
              className={classes.titleText}
              aria-describedby={ariaDescribedBy}
              tagName={as}
              size={size}
              weight="thin"
              flip
              ellipsis
            >
              {title}
            </Text>
          )}
        </div>

        {suffix && (
          <div className={classes.suffix} data-hook="suffix-node">
            {suffix}
          </div>
        )}
      </div>
    );
  },
);

SectionHeader.displayName = 'SectionHeader';

SectionHeader.propTypes = {
  title: PropTypes.any.isRequired,
  suffix: PropTypes.any,
  dataHook: PropTypes.string,
  skin: PropTypes.oneOf(['standard', 'neutral', 'light']),
  as: PropTypes.oneOf(['span', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  id: PropTypes.string,
  'aria-describedby': PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium']),
  align: PropTypes.oneOf(['start', 'center']),
  divider: PropTypes.oneOf(['default', 'top', 'bottom', 'none']),
  horizontalPadding: PropTypes.oneOf([
    'large',
    'medium',
    'small',
    'tiny',
    'xTiny',
    'xxTiny',
  ]),
};

export default SectionHeader;
